import { render } from "./LeadsDetail.vue?vue&type=template&id=4fe8bb28&scoped=true"
import script from "./LeadsDetail.vue?vue&type=script&lang=js"
export * from "./LeadsDetail.vue?vue&type=script&lang=js"

import "./LeadsDetail.vue?vue&type=style&index=0&id=4fe8bb28&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javier.padilla\\git-repositories\\proyectos.ges.com\\com.ges.proyectos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe8bb28"]])

export default __exports__